import { connect } from 'react-redux';
import {
  fetchPurchaseReturns,
  selectPurchaseReturn,
  resetCurrentPurchaseReturn,
  voidPurchaseReturn,
} from '../../actions/purchaseReturns_actions';
import { printPurchaseReturn, printPurchaseReturnNoSubtotals } from '../../actions/print_actions';
import PurchaseReturnList from '../../components/Purchase/purchaseReturnList';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

function mapStateToProps(state) {
  return {
    currentPurchaseReturn: state.purchaseReturns.currentPurchaseReturn,
    purchaseReturns: state.purchaseReturns.all,
    isLoading: state.purchaseReturns.isLoading,
    error: state.purchaseReturns.error,
    userPermissions: state.auth.userPermissions,
    requestingPurchaseReturnPdf: state.print.requestingPurchaseReturnPdf,
    purchaseReturnPdf: state.print.purchaseReturnPdf,
    purchaseReturnIsVoiding: state.purchaseReturns.purchaseReturnIsVoiding,
    purchaseReturnVoidError: state.purchaseReturns.purchaseReturnVoidError,
    purchaseReturnVoided: state.purchaseReturns.purchaseReturnVoided,

    checkPassword: state.settings.checkPassword,
    checkPasswordSuccess: state.settings.checkPasswordSuccess,
    checkPasswordFailure: state.settings.checkPasswordFailure,
    purchaseReturnPdfNs: state.print.purchaseReturnPdfNs,
  };
}

export default connect(mapStateToProps, {
  fetchPurchaseReturns,
  selectPurchaseReturn,
  resetCurrentPurchaseReturn,
  printPurchaseReturn,
  voidPurchaseReturn,
  checkPassword,
  clearCheckPassword,
  printPurchaseReturnNoSubtotals,
})(PurchaseReturnList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseReturnList.jsx